import React from "react";
import { Grid, Typography, TextField, Divider } from "@mui/material";
import { useTranslation } from "react-i18next";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { tr } from "date-fns/esm/locale";

const CounterMeasures = (props) => {
    const { t } = useTranslation();
    return (
        <>
            {/*COUNTERMEASURES*/}
            <Grid item xs={12} sm={12}>
                <Grid item xs={12} sm={12}>
                    <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold", backgroundColor: "#DEE0E0" }}>
                        {t("Countermeasures")}
                    </Typography>
                </Grid>
                {/*Actions for conversation*/}
                <Grid container xs={12} sm={12}>
                    {/* A1 */}
                    <Grid container xs={12} sm={12}>
                        <Grid item xs={1} sm={1} sx={{ display: "grid", alignContent: "center" }}></Grid>
                        <Divider orientation="vertical" flexItem sx={{ mr: "-1px" }} />
                        <Grid item xs={1} sm={1} sx={{ display: "grid", alignContent: "center" }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 13, fontWeight: "bold" }}>
                                A1.
                            </Typography>
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} sx={{ display: "grid", padding: 0.5 }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 13, fontWeight: "bold" }}>
                                {t("CounterMeasureWhat")}
                            </Typography>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                <TextField
                                    size="small"
                                    type="primary"
                                    rows={2}
                                    multiline
                                    disabled={props.disableStates.isA1WhatDisable}
                                    value={props.a1What || null}
                                    InputProps={{ style: props.inputStyle }}
                                    onChange={(e) => props.setA1What(e.target.value)}
                                    fullWidth
                                ></TextField>
                            </Typography>
                        </Grid>
                        <Grid item xs={3.4} sm={3.4} md={3.4} sx={{ display: "grid", padding: 0.5 }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 13, fontWeight: "bold" }}>
                                {t("CounterMeasureWho")}
                            </Typography>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold"}}>
                                <TextField
                                    size="small"
                                    type="primary"
                                    rows={2}
                                    multiline
                                    disabled={props.disableStates.isA1WhoDisable}
                                    value={props.a1Who || null}
                                    InputProps={{ style: props.inputStyle }}
                                    onChange={(e) => props.setA1Who(e.target.value)}
                                    fullWidth
                                ></TextField>
                            </Typography>
                        </Grid>
                        <Grid item xs={2.6} sm={2.6} md={2.6} sx={{ display: "grid", padding: 0.5 }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 13, fontWeight: "bold" }}>
                                {t("CounterMeasureWhen")}
                            </Typography>
                            <Typography variant="h6" align="center" sx={{ fontSize: 12, fontWeight: "bold" }}>
                                <LocalizationProvider id="bl_table_LocalizationProvider _2" dateAdapter={AdapterDateFns} locale={tr}>
                                    <DatePicker
                                        id="bl_table_DatePicker _13"
                                        renderInput={(_props) => (
                                            <TextField
                                                {..._props}
                                                size="small"
                                                error={false}
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        minHeight: 50,
                                                    },
                                                }}
                                            />
                                        )}
                                        inputFormat="dd.MM.yyyy"
                                        disabled={props.disableStates.isA1WhenDisable}
                                        value={props.a1When}
                                        label={t("Date")}
                                        onChange={(date) => props.setA1When(date)}
                                        ampm={false}
                                        minDate={new Date()}
                                    />
                                </LocalizationProvider>
                            </Typography>
                        </Grid>
                    </Grid>
                    {/* A2 */}
                    <Grid container xs={12} sm={12}>
                        <Grid item xs={1} sm={1} sx={{ display: "flex", justifyContent: "center" }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: "0.625rem", fontWeight: "bold", transform: "rotate(-90deg)" }}>
                                {t("ActionsForConversation")}
                            </Typography>
                        </Grid>
                        <Divider orientation="vertical" flexItem sx={{ mr: "-1px" }} />
                        <Grid item xs={1} sm={1} sx={{ display: "grid", alignContent: "center" }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 13, fontWeight: "bold" }}>
                                A2.
                            </Typography>
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} sx={{ display: "grid", padding: 0.5, margin: "auto" }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                <TextField
                                    size="small"
                                    type="primary"
                                    rows={2}
                                    multiline
                                    disabled={props.disableStates.isA2WhatDisable}
                                    value={props.a2What || null}
                                    InputProps={{ style: props.inputStyle }}
                                    onChange={(e) => props.setA2What(e.target.value)}
                                    fullWidth
                                ></TextField>
                            </Typography>
                        </Grid>
                        <Grid item xs={3.4} sm={3.4} md={3.4} sx={{ display: "grid", padding: 0.5, margin: "auto" }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                <TextField
                                    size="small"
                                    type="primary"
                                    rows={2}
                                    multiline
                                    disabled={props.disableStates.isA2WhoDisable}
                                    value={props.a2Who || null}
                                    InputProps={{ style: props.inputStyle }}
                                    onChange={(e) => props.setA2Who(e.target.value)}
                                    fullWidth
                                ></TextField>
                            </Typography>
                        </Grid>
                        <Grid item xs={2.6} sm={2.6} md={2.6} sx={{ display: "grid", padding: 0.5, margin: "auto" }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 12, fontWeight: "bold" }}>
                                <LocalizationProvider id="bl_table_LocalizationProvider _2" dateAdapter={AdapterDateFns} locale={tr}>
                                    <DatePicker
                                        id="bl_table_DatePicker _13"
                                        renderInput={(_props) => (
                                            <TextField
                                                {..._props}
                                                size="small"
                                                error={false}
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        minHeight: 50,
                                                    },
                                                }}
                                            />
                                        )}
                                        inputFormat="dd.MM.yyyy"
                                        disabled={props.disableStates.isA2WhenDisable}
                                        value={props.a2When}
                                        label={t("Date")}
                                        onChange={(date) => props.setA2When(date)}
                                        ampm={false}
                                        minDate={new Date()}
                                    />
                                </LocalizationProvider>
                            </Typography>
                        </Grid>
                    </Grid>
                    {/* A3 */}
                    <Grid container xs={12} sm={12}>
                        <Grid item xs={1} sm={1} sx={{ display: "grid", alignContent: "center" }}></Grid>
                        <Divider orientation="vertical" flexItem sx={{ mr: "-1px" }} />
                        <Grid item xs={1} sm={1} sx={{ display: "grid", alignContent: "center" }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 13, fontWeight: "bold" }}>
                                A3.
                            </Typography>
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} sx={{ display: "grid", padding: 0.5, margin: "auto" }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                <TextField
                                    size="small"
                                    type="primary"
                                    rows={2}
                                    multiline
                                    disabled={props.disableStates.isA3WhatDisable}
                                    value={props.a3What || null}
                                    InputProps={{ style: props.inputStyle }}
                                    onChange={(e) => props.setA3What(e.target.value)}
                                    fullWidth
                                ></TextField>
                            </Typography>
                        </Grid>
                        <Grid item xs={3.4} sm={3.4} md={3.4} sx={{ display: "grid", padding: 0.5, margin: "auto" }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                <TextField
                                    size="small"
                                    type="primary"
                                    rows={2}
                                    multiline
                                    disabled={props.disableStates.isA3WhoDisable}
                                    value={props.a3Who || null}
                                    InputProps={{ style: props.inputStyle }}
                                    onChange={(e) => props.setA3Who(e.target.value)}
                                    fullWidth
                                ></TextField>
                            </Typography>
                        </Grid>
                        <Grid item xs={2.6} sm={2.6} md={2.6} sx={{ display: "grid" }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 12, fontWeight: "bold", padding: 0.5 }}>
                                <LocalizationProvider id="bl_table_LocalizationProvider _2" dateAdapter={AdapterDateFns} locale={tr}>
                                    <DatePicker
                                        id="bl_table_DatePicker _13"
                                        renderInput={(_props) => (
                                            <TextField
                                                {..._props}
                                                size="small"
                                                error={false}
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        minHeight: 50,
                                                    },
                                                }}
                                            />
                                        )}
                                        inputFormat="dd.MM.yyyy"
                                        disabled={props.disableStates.isA3WhenDisable}
                                        value={props.a3When}
                                        label={t("Date")}
                                        onChange={(date) => props.setA3When(date)}
                                        ampm={false}
                                        minDate={new Date()}
                                    />
                                </LocalizationProvider>
                            </Typography>
                        </Grid>
                    </Grid>
                    {/* A4  */}
                    <Grid container xs={12} sm={12}>
                        <Grid item xs={1} sm={1} sx={{ display: "grid", alignContent: "center" }}></Grid>
                        <Divider orientation="vertical" flexItem sx={{ mr: "-1px" }} />
                        <Grid item xs={1} sm={1} sx={{ display: "grid", alignContent: "center" }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 13, fontWeight: "bold" }}>
                                A4.
                            </Typography>
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} sx={{ display: "grid", padding: 0.5,margin: "auto" }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                <TextField
                                    size="small"
                                    type="primary"
                                    rows={2}
                                    multiline
                                    disabled={props.disableStates.isA4WhatDisable}
                                    value={props.a4What || null}
                                    InputProps={{ style: props.inputStyle }}
                                    onChange={(e) => props.setA4What(e.target.value)}
                                    fullWidth
                                ></TextField>
                            </Typography>
                        </Grid>
                        <Grid item xs={3.4} sm={3.4} md={3.4} sx={{ display: "grid", padding: 0.5,margin: "auto" }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                <TextField
                                    size="small"
                                    type="primary"
                                    rows={2}
                                    multiline
                                    disabled={props.disableStates.isA4WhoDisable}
                                    value={props.a4Who || null}
                                    InputProps={{ style: props.inputStyle }}
                                    onChange={(e) => props.setA4Who(e.target.value)}
                                    fullWidth
                                ></TextField>
                            </Typography>
                        </Grid>
                        <Grid item xs={2.6} sm={2.6} md={2.6} sx={{ display: "grid", padding: 0.5, margin: "auto" }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 12, fontWeight: "bold" }}>
                                <LocalizationProvider id="bl_table_LocalizationProvider _2" dateAdapter={AdapterDateFns} locale={tr}>
                                    <DatePicker
                                        id="bl_table_DatePicker _13"
                                        renderInput={(_props) => (
                                            <TextField
                                                {..._props}
                                                size="small"
                                                error={false}
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        minHeight: 50,
                                                    },
                                                }}
                                            />
                                        )}
                                        inputFormat="dd.MM.yyyy"
                                        disabled={props.disableStates.isA4WhenDisable}
                                        value={props.a4When}
                                        label={t("Date")}
                                        onChange={(date) => props.setA4When(date)}
                                        ampm={false}
                                        minDate={new Date()}
                                    />
                                </LocalizationProvider>
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <Divider orientation="horizontal" flexItem sx={{ mb: "-1px", height: "2px", backgroundColor: "black" }} />
                    </Grid>
                </Grid>
                {/*Actions against the root cause*/}
                <Grid container xs={12} sm={12}>
                    <Grid container xs={12} sm={12}>
                        <Grid item xs={1} sm={1} sx={{ display: "grid", alignContent: "center" }}></Grid>
                        <Divider orientation="vertical" flexItem sx={{ mr: "-1px" }} />
                        <Grid item xs={1} sm={1} sx={{ display: "grid", alignContent: "center" }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 13, fontWeight: "bold" }}>
                                AM.
                            </Typography>
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} sx={{ display: "grid", padding: 0.5, margin: "auto" }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                <TextField
                                    size="small"
                                    type="primary"
                                    rows={2}
                                    multiline
                                    disabled={props.disableStates.isAmWhatDisable}
                                    value={props.amWhat || null}
                                    InputProps={{ style: props.inputStyle }}
                                    onChange={(e) => props.setAmWhat(e.target.value)}
                                    fullWidth
                                ></TextField>
                            </Typography>
                        </Grid>
                        <Grid item xs={3.4} sm={3.4} md={3.4} sx={{ display: "grid", padding: 0.5, margin: "auto" }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                <TextField
                                    size="small"
                                    type="primary"
                                    rows={2}
                                    multiline
                                    disabled={props.disableStates.isAmWhoDisable}
                                    value={props.amWho || null}
                                    InputProps={{ style: props.inputStyle }}
                                    onChange={(e) => props.setAmWho(e.target.value)}
                                    fullWidth
                                ></TextField>
                            </Typography>
                        </Grid>
                        <Grid item xs={2.6} sm={2.6} md={2.6} sx={{ display: "grid", padding: 0.5,margin: "auto" }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 12, fontWeight: "bold" }}>
                                <LocalizationProvider id="bl_table_LocalizationProvider _2" dateAdapter={AdapterDateFns} locale={tr}>
                                    <DatePicker
                                        id="bl_table_DatePicker _13"
                                        renderInput={(_props) => (
                                            <TextField
                                                {..._props}
                                                error={false}
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        minHeight: 50,
                                                    },
                                                }}
                                            />
                                        )}
                                        inputFormat="dd.MM.yyyy"
                                        disabled={props.disableStates.isAmWhenDisable}
                                        value={props.amWhen}
                                        label={t("Date")}
                                        onChange={(date) => props.setAmWhen(date)}
                                        ampm={false}
                                        minDate={new Date()}
                                    />
                                </LocalizationProvider>
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid container xs={12} sm={12}>
                        <Grid item xs={1} sm={1} sx={{ display: "grid", alignContent: "center" }}></Grid>
                        <Divider orientation="vertical" flexItem sx={{ mr: "-1px" }} />
                        <Grid item xs={1} sm={1} sx={{ display: "grid", alignContent: "center" }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 13, fontWeight: "bold" }}>
                                FT.
                            </Typography>
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} sx={{ display: "grid", padding: 0.5 }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                <TextField
                                    size="small"
                                    type="primary"
                                    rows={2}
                                    multiline
                                    disabled={props.disableStates.isFtWhatDisable}
                                    value={props.ftWhat || null}
                                    InputProps={{ style: props.inputStyle }}
                                    onChange={(e) => props.setFtWhat(e.target.value)}
                                    fullWidth
                                ></TextField>
                            </Typography>
                        </Grid>
                        <Grid item xs={3.4} sm={3.4} md={3.4} sx={{ display: "grid", padding: 0.5 }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                <TextField
                                    size="small"
                                    type="primary"
                                    rows={2}
                                    multiline
                                    disabled={props.disableStates.isFtWhoDisable}
                                    value={props.ftWho || null}
                                    InputProps={{ style: props.inputStyle }}
                                    onChange={(e) => props.setFtWho(e.target.value)}
                                    fullWidth
                                ></TextField>
                            </Typography>
                        </Grid>
                        <Grid item xs={2.6} sm={2.6} md={2.6} sx={{ display: "grid", padding: 0.5 }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 12, fontWeight: "bold" }}>
                                <LocalizationProvider id="bl_table_LocalizationProvider _2" dateAdapter={AdapterDateFns} locale={tr}>
                                    <DatePicker
                                        id="bl_table_DatePicker _13"
                                        renderInput={(_props) => (
                                            <TextField
                                                {..._props}
                                                size="small"
                                                error={false}
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        minHeight: 50,
                                                    },
                                                }}
                                            />
                                        )}
                                        inputFormat="dd.MM.yyyy"
                                        disabled={props.disableStates.isFtWhenDisable}
                                        value={props.ftWhen}
                                        label={t("Date")}
                                        onChange={(date) => props.setFtWhen(date)}
                                        ampm={false}
                                        minDate={new Date()}
                                    />
                                </LocalizationProvider>
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid container xs={12} sm={12}>
                        <Grid item xs={1} sm={1} sx={{ display: "grid", alignContent: "center" }}></Grid>
                        <Divider orientation="vertical" flexItem sx={{ mr: "-1px" }} />
                        <Grid item xs={1} sm={1} sx={{ display: "grid", alignContent: "center" }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 13, fontWeight: "bold" }}>
                                SM.
                            </Typography>
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} sx={{ display: "grid", padding: 0.5 }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                <TextField
                                    size="small"
                                    type="primary"
                                    rows={2}
                                    multiline
                                    disabled={props.disableStates.isSmWhatDisable}
                                    value={props.smWhat || null}
                                    InputProps={{ style: props.inputStyle }}
                                    onChange={(e) => props.setSmWhat(e.target.value)}
                                    fullWidth
                                ></TextField>
                            </Typography>
                        </Grid>
                        <Grid item xs={3.4} sm={3.4} md={3.4} sx={{ display: "grid", padding: 0.5 }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                <TextField
                                    size="small"
                                    type="primary"
                                    rows={2}
                                    multiline
                                    disabled={props.disableStates.isSmWhoDisable}
                                    value={props.smWho || null}
                                    InputProps={{ style: props.inputStyle }}
                                    onChange={(e) => props.setSmWho(e.target.value)}
                                    fullWidth
                                ></TextField>
                            </Typography>
                        </Grid>
                        <Grid item xs={2.6} sm={2.6} md={2.6} sx={{ display: "grid", padding: 0.5 }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 12, fontWeight: "bold" }}>
                                <LocalizationProvider id="bl_table_LocalizationProvider _2" dateAdapter={AdapterDateFns} locale={tr}>
                                    <DatePicker
                                        id="bl_table_DatePicker _13"
                                        renderInput={(_props) => (
                                            <TextField
                                                {..._props}
                                                size="small"
                                                error={false}
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        minHeight: 50,
                                                    },
                                                }}
                                            />
                                        )}
                                        inputFormat="dd.MM.yyyy"
                                        disabled={props.disableStates.isSmWhenDisable}
                                        value={props.smWhen}
                                        label={t("Date")}
                                        onChange={(date) => props.setSmWhen(date)}
                                        ampm={false}
                                        minDate={new Date()}
                                    />
                                </LocalizationProvider>
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid container xs={12} sm={12}>
                        <Grid item xs={1} sm={1} sx={{ display: "flex", justifyContent: "center" }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: "0.625rem", fontWeight: "bold", transform: "rotate(-90deg)" }}>
                                {t("ActionsAgainstTheRootCause")}
                            </Typography>
                        </Grid>
                        <Divider orientation="vertical" flexItem sx={{ mr: "-1px" }} />
                        <Grid item xs={1} sm={1} sx={{ display: "grid", alignContent: "center" }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 13, fontWeight: "bold" }}>
                                PM.
                            </Typography>
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} sx={{ display: "grid", padding: 0.5 }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                <TextField
                                    size="small"
                                    type="primary"
                                    rows={2}
                                    multiline
                                    disabled={props.disableStates.isPmWhatDisable}
                                    value={props.pmWhat || null}
                                    InputProps={{ style: props.inputStyle }}
                                    onChange={(e) => props.setPmWhat(e.target.value)}
                                    fullWidth
                                ></TextField>
                            </Typography>
                        </Grid>
                        <Grid item xs={3.4} sm={3.4} md={3.4} sx={{ display: "grid", padding: 0.5 }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                <TextField
                                    size="small"
                                    type="primary"
                                    rows={2}
                                    multiline
                                    disabled={props.disableStates.isPmWhoDisable}
                                    value={props.pmWho || null}
                                    InputProps={{ style: props.inputStyle }}
                                    onChange={(e) => props.setPmWho(e.target.value)}
                                    fullWidth
                                ></TextField>
                            </Typography>
                        </Grid>
                        <Grid item xs={2.6} sm={2.6} md={2.6} sx={{ display: "grid", padding: 0.5 }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 12, fontWeight: "bold" }}>
                                <LocalizationProvider id="bl_table_LocalizationProvider _2" dateAdapter={AdapterDateFns} locale={tr}>
                                    <DatePicker
                                        id="bl_table_DatePicker _13"
                                        renderInput={(_props) => (
                                            <TextField
                                                {..._props}
                                                size="small"
                                                error={false}
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        minHeight: 50,
                                                    },
                                                }}
                                            />
                                        )}
                                        inputFormat="dd.MM.yyyy"
                                        disabled={props.disableStates.isPmWhenDisable}
                                        value={props.pmWhen}
                                        label={t("Date")}
                                        onChange={(date) => props.setPmWhen(date)}
                                        ampm={false}
                                        minDate={new Date()}
                                    />
                                </LocalizationProvider>
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container xs={12} sm={12}>
                        <Grid item xs={1} sm={1} sx={{ display: "grid", alignContent: "center" }}></Grid>
                        <Divider orientation="vertical" flexItem sx={{ mr: "-1px" }} />
                        <Grid item xs={1} sm={1} sx={{ display: "grid", alignContent: "center" }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 13, fontWeight: "bold" }}>
                                DR.
                            </Typography>
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} sx={{ display: "grid", padding: 0.5 }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                <TextField
                                    size="small"
                                    type="primary"
                                    rows={2}
                                    multiline
                                    disabled={props.disableStates.isDrWhatDisable}
                                    value={props.drWhat || null}
                                    InputProps={{ style: props.inputStyle }}
                                    onChange={(e) => props.setDrWhat(e.target.value)}
                                    fullWidth
                                ></TextField>
                            </Typography>
                        </Grid>
                        <Grid item xs={3.4} sm={3.4} md={3.4} sx={{ display: "grid", padding: 0.5 }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                <TextField
                                    size="small"
                                    type="primary"
                                    rows={2}
                                    multiline
                                    disabled={props.disableStates.isDrWhoDisable}
                                    value={props.drWho || null}
                                    InputProps={{ style: props.inputStyle }}
                                    onChange={(e) => props.setDrWho(e.target.value)}
                                    fullWidth
                                ></TextField>
                            </Typography>
                        </Grid>
                        <Grid item xs={2.6} sm={2.6} md={2.6} sx={{ display: "grid", padding: 0.5 }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 12, fontWeight: "bold" }}>
                                <LocalizationProvider id="bl_table_LocalizationProvider _2" dateAdapter={AdapterDateFns} locale={tr}>
                                    <DatePicker
                                        id="bl_table_DatePicker _13"
                                        renderInput={(_props) => (
                                            <TextField
                                                {..._props}
                                                size="small"
                                                error={false}
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        minHeight: 50,
                                                    },
                                                }}
                                            />
                                        )}
                                        inputFormat="dd.MM.yyyy"
                                        disabled={props.disableStates.isDrWhenDisable}
                                        value={props.drWhen}
                                        label={t("Date")}
                                        onChange={(date) => props.setDrWhen(date)}
                                        ampm={false}
                                        minDate={new Date()}
                                    />
                                </LocalizationProvider>
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container xs={12} sm={12}>
                        <Grid item xs={1} sm={1} sx={{ display: "grid", alignContent: "center" }}></Grid>
                        <Divider orientation="vertical" flexItem sx={{ mr: "-1px" }} />
                        <Grid item xs={1} sm={1} sx={{ display: "grid", alignContent: "center" }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 13, fontWeight: "bold" }}>
                                AS.
                            </Typography>
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} sx={{ display: "grid", padding: 0.5 }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                <TextField
                                    size="small"
                                    type="primary"
                                    rows={2}
                                    multiline
                                    disabled={props.disableStates.isAsWhatDisable}
                                    value={props.asWhat || null}
                                    InputProps={{ style: props.inputStyle }}
                                    onChange={(e) => props.setAsWhat(e.target.value)}
                                    fullWidth
                                ></TextField>
                            </Typography>
                        </Grid>
                        <Grid item xs={3.4} sm={3.4} md={3.4} sx={{ display: "grid", padding: 0.5 }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                <TextField
                                    size="small"
                                    type="primary"
                                    rows={2}
                                    multiline
                                    disabled={props.disableStates.isAsWhoDisable}
                                    value={props.asWho || null}
                                    InputProps={{ style: props.inputStyle }}
                                    onChange={(e) => props.setAsWho(e.target.value)}
                                    fullWidth
                                ></TextField>
                            </Typography>
                        </Grid>
                        <Grid item xs={2.6} sm={2.6} md={2.6} sx={{ display: "grid", padding: 0.5 }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 12, fontWeight: "bold" }}>
                                <LocalizationProvider id="bl_table_LocalizationProvider _2" dateAdapter={AdapterDateFns} locale={tr}>
                                    <DatePicker
                                        id="bl_table_DatePicker _13"
                                        renderInput={(_props) => (
                                            <TextField
                                                {..._props}
                                                size="small"
                                                error={false}
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        minHeight: 50,
                                                    },
                                                }}
                                            />
                                        )}
                                        inputFormat="dd.MM.yyyy"
                                        disabled={props.disableStates.isAsWhenDisable}
                                        value={props.asWhen}
                                        label={t("Date")}
                                        onChange={(date) => props.setAsWhen(date)}
                                        ampm={false}
                                        minDate={new Date()}
                                    />
                                </LocalizationProvider>
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container xs={12} sm={12}>
                        <Grid item xs={1} sm={1} sx={{ display: "grid", alignContent: "center" }}></Grid>
                        <Divider orientation="vertical" flexItem sx={{ mr: "-1px" }} />
                        <Grid item xs={1} sm={1} sx={{ display: "grid", alignContent: "center" }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 13, fontWeight: "bold" }}>
                                PL.
                            </Typography>
                        </Grid>
                        <Grid item xs={4} sm={4} md={4} sx={{ display: "grid", padding: 0.5 }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                <TextField
                                    size="small"
                                    type="primary"
                                    rows={2}
                                    multiline
                                    disabled={props.disableStates.isPlWhatDisable}
                                    value={props.plWhat || null}
                                    InputProps={{ style: props.inputStyle }}
                                    onChange={(e) => props.setPlWhat(e.target.value)}
                                    fullWidth
                                ></TextField>
                            </Typography>
                        </Grid>
                        <Grid item xs={3.4} sm={3.4} md={3.4} sx={{ display: "grid", padding: 0.5 }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold" }}>
                                <TextField
                                    size="small"
                                    type="primary"
                                    rows={2}
                                    multiline
                                    disabled={props.disableStates.isPlWhoDisable}
                                    value={props.plWho || null}
                                    InputProps={{ style: props.inputStyle }}
                                    onChange={(e) => props.setPlWho(e.target.value)}
                                    fullWidth
                                ></TextField>
                            </Typography>
                        </Grid>
                        <Grid item xs={2.6} sm={2.6} md={2.6} sx={{ display: "grid", padding: 0.5 }}>
                            <Typography variant="h6" align="center" sx={{ fontSize: 12, fontWeight: "bold" }}>
                                <LocalizationProvider id="bl_table_LocalizationProvider _2" dateAdapter={AdapterDateFns} locale={tr}>
                                    <DatePicker
                                        id="bl_table_DatePicker _13"
                                        renderInput={(_props) => (
                                            <TextField
                                                {..._props}
                                                size="small"
                                                error={false}
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        minHeight: 50,
                                                    },
                                                }}
                                            />
                                        )}
                                        disabled={props.disableStates.isPlWhenDisable}
                                        value={props.plWhen || null}
                                        label={t("Date")}
                                        onChange={(date) => props.setPlWhen(date)}
                                        ampm={false}
                                        minDate={new Date()}
                                    />
                                </LocalizationProvider>
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
};

export default CounterMeasures;
